module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-17.2d38dd80.png";